<template>
  <div v-if="rating">
    <b-tooltip :label="`Rating: ${rating}`" type="is-info">
      <div class="control">
        <b-taglist attached>
          <b-tag type="is-info is-light rating" :class="`rating--${type}`">
            <span class="icon " :class="`rating-icon--${type}`">
              <i class="fab fa-jedi-order" />
            </span>
            {{ rating }}
          </b-tag>
          <b-tag
            v-if="diff"
            class="rating"
            :class="`rating-diff--${type}`"
            :type="`is-${diff > 0 ? 'success' : 'danger'} is-light`"
          >
            <b-icon :icon="diff > 0 ? 'arrow-up' : 'arrow-down'" />{{
              Math.abs(diff)
            }}
          </b-tag>
        </b-taglist>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "PlayerRating",
  props: ["rating", "diff", "type"],
};
</script>

<style scoped>
.rating {
  padding: 0 0.25rem 0 0;
}

.rating-icon--large {
  margin: 0 !important;
}

.rating--large {
  padding-left: 0.25rem;
  font-size: 1.5em;
  font-weight: 700;
  height: 3rem;
}

.rating-diff--large {
  /* padding: 0 0.25rem; */
  font-size: 1rem;
  font-weight: 700;
  min-width: 2.25rem;
  height: 3rem;
}

.rating--undefined {
  padding: 0 0.15rem;
  font-weight: 600;
}
</style>
